module.exports = __webpack_public_path__ + "static/img/3.3dc19d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bootcamp/enroll/cards/benjyfishy/3.png
// module id = Lfp4
// module chunks = 35